export default "__VITE_ASSET__DI8iQdM3__"